import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { statusClass } from 'src/app/model/constants';
import { HomeApiService } from './api/home.api.service';
import { ICarouselHomeImages , IHomePageText} from './api/home.interface';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./journey.scss', './pujas.scss', './fly-above.scss', './shaktipeethtv.scss', './calender.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router, private homeApiService: HomeApiService) { }

  carouselHomeScreen: ICarouselHomeImages[];
  carouselHomeText = {} as IHomePageText;
  homePagePuja = {} as any;
  homePagePujaList: any;
  homePageexploreList: any;
  homePageShaktipeethTVList: any;
  homePageTestimonialList: any;

  ngOnInit(): void {
    this.getHomePageText();
    this.getHomePageCarosual();
    this.getHomePagePujaData();
    this.getCmsHolder();
    this.getHomePageTestimonial();
    this.getHomePageShaktipeethTVList();
  }

  gotoExplore(): void{
    this.router.navigate(['pooja']);
  }

  getHomePageCarosual(): void {
    this.homeApiService.getHomePageBanners().subscribe(req => {
      if (req.code === statusClass.overall_success_response){
        this.carouselHomeScreen = req.data ? req.data.topBanner : null;
        // console.log(req.data.bannerText);
        this.carouselHomeText.bannerHoardingText = req.data.bannerTitle;
        this.carouselHomeText.bannerHoardingDesc = req.data.bannerText;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  getHomePageText(): void {
    // this.homeApiService.getHomePageText().subscribe(req => {
    //   if (req.code === statusClass.overall_success_response){
    //     this.carouselHomeText = req.data ? req.data : null;
    //   }
    // }, (error: any) => {
    //   console.log(error);
    // });
  }

  getHomePagePujaData(): void {
    this.homeApiService.getHomePagePoojaData().subscribe(req => {
      if (req.code === statusClass.overall_success_response){
        // this.homePagePuja = req ? req : null;
        this.homePagePujaList = req.data ? req.data : null;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  getHomePageShaktipeethTVList(): void {
    this.homeApiService.getHomePageShaktipeethTVList().subscribe(req => {
      if (req.code === statusClass.overall_success_response){
        this.homePageShaktipeethTVList = req.data ? [...req.data] : null;
        this.homePageexploreList = req.data ? req.data.splice(0 , 3) : null;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  getHomePageTestimonial(): void {
    this.homeApiService.getTestimonialList().subscribe(req => {
      if (req.code === statusClass.overall_success_response){
        this.homePageTestimonialList = req.data ? [...req.data] : null;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  getCmsHolder(): void {
    this.homeApiService.getCMSOurService().subscribe(res => {
      this.carouselHomeText.journeyText = res.data;

      this.homePagePuja.mainTitle = res.data.joinInPrayerTitle;
      this.homePagePuja.contentDescription = res.data.joinInPrayer;

      // carouselHomeText?.ropewayText?.banner
    }, (error: any) => {

    });
  }

}
